module.exports = __webpack_public_path__ + "img/fnbbg.70bd9a75.jpg";